import { render, staticRenderFns } from "./list-clients.vue?vue&type=template&id=62cece95"
import script from "./list-clients.vue?vue&type=script&lang=js"
export * from "./list-clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports